import { NgModule } from '@angular/core';
import {MaterialModule} from '../material-module/material-module.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CustomCarouselComponent} from '@components/custom-carousel/custom-carousel.component';
import {GooglePlaceModule} from 'ngx-google-places-autocomplete';
import {CountriesFlagsComponent} from '@components/countries-flags/countries-flags.component';
import {AddressComponent} from '@components/address/address.component';
import {AngularMultiSelectModule} from '@node_modules/angular2-multiselect-dropdown';
import {ListMembersComponent} from '@components/list-members/list-members.component';
import {CommonModule} from '@node_modules/@angular/common';
import {CalendarComponent} from '@components/calendar/calendar.component';
import {CreateProgramSubscriptionComponent} from '@pages/layout/program/program-page/program-payment/create-program-subscription/create-program-subscription.component';
import {CreateProgramCurriculumComponent} from '@pages/layout/program/program-page/program-curriculum/create-program-curriculum/create-program-curriculum.component';
import {ConfirmModalComponent} from '@components/confirm-modal/confirm-modal.component';
import {ProgramScheduleComponent} from '@pages/layout/program/program-page/program-schedule/program-schedule.component';
import {ProgramScheduleWeekComponent} from '@pages/layout/program/program-page/program-schedule/program-schedule-week/program-schedule-week.component';
import {ProgramScheduleDayComponent} from '@pages/layout/program/program-page/program-schedule/program-schedule-day/program-schedule-day.component';
import {ProgramScheduleMonthComponent} from '@pages/layout/program/program-page/program-schedule/program-schedule-month/program-schedule-month.component';
import {ViewCurriculumComponent} from '@pages/layout/program/program-page/program-curriculum/view-curriculum/view-curriculum.component';
import {AttendanceOverviewComponent} from '@components/attendance-overview/attendance-overview.component';
import {ViewMonthCurriculumComponent} from '@components/view-month-curriculum/view-month-curriculum.component';
import {AngularEditorModule} from '@node_modules/@kolkov/angular-editor';
import {SafeHtmlPipe} from '@app/pipes/SafeHtmlPipe';
import {ModalCalendarComponent} from '@components/modal-calendar/modal-calendar.component';
import {PaymentsPageComponent} from '@pages/layout/payments/payments-page/payments-page.component';
import {TermsComponent} from '@components/terms/terms.component';
import {TermsPdfComponent} from '@components/terms-pdf/terms-pdf.component';
import {CheckInOptionsComponent} from '@components/check-in-options/check-in-options.component';
import {CheckInsTeacherComponent} from '@components/check-ins-teacher/check-ins-teacher.component';
import {AttendanceTeacherComponent} from '@components/attendance-teacher/attendance-teacher.component';
import {TrialStudentsComponent} from '@components/trial-students/trial-students.component';
import {PaymentsTeacherComponent} from '@components/payments-teacher/payments-teacher.component';
import {OnboardingRegisterComponent} from '@components/onboarding-register/onboarding-register.component';
import {RegisterComponent} from '@pages/auth/register/register.component';
import {SearchPeopleComponent} from '@components/search-people/search-people.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import {MainSpinnerComponent} from '@components/main-spinner/main-spinner.component';
import {StudentsProgramsListingComponent} from '@pages/layout/program/program-page/students-programs-listing/students-programs-listing.component';
import {SearchProgramsComponent} from '@components/search-programs/search-programs.component';
import {ProgramViewComponent} from '@components/program-view/program-view.component';
import {ManageAdminSubscriptionDialog} from '@components/manage-admin-subscription-dialog/manage-admin-subscription-dialog.component';
import {RechargeFailedChargeStudentDialog} from '@components/recharge-failed-charge-student-dialog/recharge-failed-charge-student-dialog.component';
import {StudentStatisticWidgetComponent} from '@components/student-statistic-widget/student-statistic-widget.component';
import {RouterModule} from '@node_modules/@angular/router';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    AngularEditorModule,
    GooglePlaceModule,
    AngularMultiSelectModule,
    PdfViewerModule,
    RouterModule
  ],
  declarations: [
    CustomCarouselComponent,
    CountriesFlagsComponent,
    AddressComponent,
    ListMembersComponent,
    CalendarComponent,
    CreateProgramSubscriptionComponent,
    CreateProgramCurriculumComponent,
    ConfirmModalComponent,
    ProgramScheduleComponent,
    ProgramScheduleWeekComponent,
    ProgramScheduleDayComponent,
    ProgramScheduleMonthComponent,
    ViewCurriculumComponent,
    AttendanceOverviewComponent,
    ViewMonthCurriculumComponent,
    SafeHtmlPipe,
    ModalCalendarComponent,
    PaymentsPageComponent,
    TermsComponent,
    TermsPdfComponent,
    CheckInOptionsComponent,
    CheckInsTeacherComponent,
    AttendanceTeacherComponent,
    TrialStudentsComponent,
    PaymentsTeacherComponent,
    OnboardingRegisterComponent,
    MainSpinnerComponent,
    SearchProgramsComponent,
    ProgramViewComponent,
    // RegisterComponent
    SearchPeopleComponent,
    StudentsProgramsListingComponent,
    ManageAdminSubscriptionDialog,
    RechargeFailedChargeStudentDialog,
    StudentStatisticWidgetComponent,
  ],
  exports: [
    ProgramViewComponent,
    MainSpinnerComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AngularEditorModule,
    MaterialModule,
    CustomCarouselComponent,
    GooglePlaceModule,
    CountriesFlagsComponent,
    AddressComponent,
    AngularMultiSelectModule,
    ListMembersComponent,
    CalendarComponent,
    CreateProgramCurriculumComponent,
    ConfirmModalComponent,
    ProgramScheduleComponent,
    ProgramScheduleWeekComponent,
    ProgramScheduleDayComponent,
    ProgramScheduleMonthComponent,
    ViewCurriculumComponent,
    AttendanceOverviewComponent,
    ViewMonthCurriculumComponent,
    SafeHtmlPipe,
    ModalCalendarComponent,
    PaymentsPageComponent,
    TermsComponent,
    TermsPdfComponent,
    CheckInOptionsComponent,
    CheckInsTeacherComponent,
    AttendanceTeacherComponent,
    TrialStudentsComponent,
    PaymentsTeacherComponent,
    OnboardingRegisterComponent,
    SearchProgramsComponent,
    // RegisterComponent
    SearchPeopleComponent,
    StudentsProgramsListingComponent,
    ManageAdminSubscriptionDialog,
    RechargeFailedChargeStudentDialog,
    StudentStatisticWidgetComponent,
  ],
  providers: [
  ]
})

export class SharedModule {}
